import gql from 'graphql-tag'

const deleteShortUrlMutation = gql`
  mutation DeleteShortUrl($id: String!) {
    deleteShortUrl(id: $id)
  }
`

export default deleteShortUrlMutation
